export default "__VITE_ASSET__526188ad__"